document.addEventListener("DOMContentLoaded", () => {
  const switcher = document.querySelector("[data-country-switcher]")

  if (!switcher) return

  const staticUrls = [
    { url: "https://www.morgenland-rugs.com", country: "us", lang: "en" },
    { url: "https://www.morgenland-rugs.co.uk", country: "uk", lang: "en" },
    { url: "https://www.morgenland-tapis.fr", country: "fr", lang: "fr" },
    { url: "https://www.morgenland-tapijt.nl", country: "nl", lang: "nl" },
    { url: "https://www.morgenland-mattor.se", country: "se", lang: "se" },
    { url: "https://www.morgenland-teppiche.at", country: "at", lang: "de" },
    { url: "https://www.morgenland-tepper.com", country: "no", lang: "nn" },
    { url: "https://www.morgenland-taepper.com", country: "dk", lang: "da" },
    { url: "https://www.morgenland-alfombra.es", country: "es", lang: "es" },
    { url: "https://www.morgenland-tappeto.it", country: "it", lang: "it" },
    { url: "https://www.morgenland-dywany.pl", country: "pl", lang: "pl" },
    { url: "https://www.morgenland-tapetes.pt", country: "pt", lang: "pt" },
    { url: "https://www.morgenland-koberce.cz", country: "cz", lang: "cz" },
  ]
  const allCountryLinks = document.querySelectorAll("a[data-country]")
  const pageContext = switcher.dataset.pageContext
  const collectionId = JSON.parse(switcher.dataset.collectionId || "null")
  const variantId = JSON.parse(switcher.dataset.variantId || "null")
  const itemId = JSON.parse(switcher.dataset.itemId || "null")
  const articleId = JSON.parse(switcher.dataset.articleId || "null")

  function updateLinks(data) {
    const linksByLang = {}
    ;(data?.data || []).forEach((item) => {
      const langKey = item.locale || item.lang
      if (!langKey) return
      if (item.full_url?.startsWith("http")) {
        linksByLang[langKey] = item.full_url
      } else if (item.url) {
        const site = staticUrls.find((s) => s.lang === langKey)
        if (site) {
          linksByLang[langKey] = site.url + item.url
        }
      }
    })
    allCountryLinks.forEach((link) => {
      const country = link.dataset.country.toLowerCase()
      const site = staticUrls.find((s) => s.country === country)
      if (site && linksByLang[site.lang]) {
        const fullUrl = linksByLang[site.lang]
        link.href = fullUrl
        document.querySelectorAll('link[rel="alternate"]').forEach((alt) => {
          if (alt.href.startsWith(site.url)) {
            alt.href = fullUrl
          }
        })
      }
    })
  }

  if (pageContext === "collection" && collectionId) {
    fetch(`https://node-api.morgenland-cpanel.eu/categories/locale-interlinking?category_id=${collectionId}`)
      .then((res) => res.json())
      .then(updateLinks)
      .catch(console.error)
  } else if (pageContext === "product" && variantId) {
    fetch(
      `https://node-api.morgenland-cpanel.eu/variants/locale-interlinking?item_id=${itemId}&variant_id=${variantId}`
    )
      .then((res) => res.json())
      .then(updateLinks)
      .catch(console.error)
  } else if (pageContext === "article" && articleId) {
    fetch(`https://morgenland-cpanel.eu/api/morgenland-blogs/all-interlinkings?blog_group_id=${articleId}`)
      .then((res) => res.json())
      .then(updateLinks)
      .catch(console.error)
  }
})
